import { intervalToDuration } from "date-fns";
import { getNow, parseDateOnly } from "@/lib/time";

const ADULT_AGE = 18;

export enum AgeStatus {
  // the public information of the user is not loaded yet
  UNKNOWN = "UNKNOWN",
  // the user has not told the birth date yet
  MISSING = "MISSING",
  MINOR = "MINOR",
  ADULT = "ADULT",
}

export const isAdult = (dateOfBirth: string | Date): boolean => {
  const { years = 0 } = intervalToDuration({ start: parseDateOnly(dateOfBirth), end: getNow() });
  return years >= ADULT_AGE;
};
